import React, { useEffect, useState, useReducer, useCallback } from 'react';
import { Link, useNavigate } from "react-router-dom";
import './Footer.less'

export default function Footer() {
  const navigate = useNavigate();
  const scrollTop = () => {
    document.scrollingElement.scrollTop = 0
  }


  const initialState = {
    isAboutOpen: false,
    isProductsOpen: false,
    isNewsOpen: false,
    isFcstOpen: false,
    isContactOpen: false,
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_ABOUT":
        return { isAboutOpen: !state.isAboutOpen, isProductsOpen: false, isNewsOpen: false, isFcstOpen: false, isContactOpen: false };
      case "TOGGLE_PRODUCTS":
        return { isAboutOpen: false, isProductsOpen: !state.isProductsOpen, isNewsOpen: false, isFcstOpen: false, isContactOpen: false };
      case "TOGGLE_NEWS":
        return { isAboutOpen: false, isProductsOpen: false, isNewsOpen: !state.isNewsOpen, isFcstOpen: false, isContactOpen: false };
      case "TOGGLE_FCST":
        return { isAboutOpen: false, isProductsOpen: false, isNewsOpen: false, isFcstOpen: !state.isFcstOpen, isContactOpen: false };
      case "TOGGLE_CONTACT":
        return { isAboutOpen: false, isProductsOpen: false, isNewsOpen: false, isFcstOpen: false, isContactOpen: !state.isContactOpen };
      default:
        return state;
    }
  }

  const menuItems = [
    {
      title: "关于我们",
      type: "ABOUT",
      links: [
        { text: "公司介绍", href: "/aboutUs" },
        { text: "发展历程", href: "/aboutUs" },
      ],
    },
    {
      title: "产品及解决方案",
      type: "PRODUCTS",
      links: [
        { text: "ARTA 埃尔塔®视觉功能训练治疗软件", href: "/arta" },
        // { text: "ARTA 埃尔塔®全年龄弱视治疗仪", href: "/arta" },
        { text: "ARGOS 爱格视™全功能3D近视训练仪", href: "/argos" },
        { text: "EYEPAL 眼派™可视温润舒眼仪", href: "/eyepal" },
        // { text: "创新青光眼治疗方案", href: "/glaucoma" },
        // { text: "斜视术后康复数字疗法", href: "/strabismus" },
      ],
    },
    {
      title: "公司动态",
      type: "NEWS",
      links: [{ text: "最新资讯", href: "/companyNews" }],
    },
    {
      title: "FCST研究院",
      type: "FCST",
      links: [
        { text: "文献速递", href: "/fcst" },
        { text: "科普专栏", href: "/fcst" },
      ],
    },
    {
      title: "联系我们",
      type: "CONTACT",
      links: [
        { text: "公司地址", href: "/aboutUs" },
        { text: "联系方式", href: "/aboutUs" },
      ],
    },
  ];

  const [state, dispatch] = useReducer(reducer, initialState);
  const { isAboutOpen, isProductsOpen, isNewsOpen, isFcstOpen, isContactOpen } = state;

  const toggleMenu = useCallback(
    (type) => (e) => {
      e.stopPropagation();
      dispatch({ type: `TOGGLE_${type}` });
      console.log('type', type,)
    },
    []
  );

  return (
    <div className="App_footer">
      <div className="App_footer-top">
        <div className='App_footer-content pageMargin'>
          <div className="App_footer-topLeft">
            <img
              className='App_footer-topImg'
              src='/images/footer.svg'
            />
          </div>
          {/* PC端 */}
          <div className='App_footer-topRight'>
            <div className='App_footer-topRightItem'>
              <div className="App_footer-title">关于我们</div>
              <Link to='/aboutUs'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                公司介绍
              </Link>
              <Link to='/aboutUs'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                发展历程
              </Link>
            </div>
            <div className='App_footer-topRightItem'>
              <div className="App_footer-title">产品及解决方案</div>
              <Link to='/arta'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                {/* ARTA 埃尔塔®全年龄弱视治疗仪 */}
                ARTA 埃尔塔®视觉功能训练治疗软件
              </Link>
              <Link to='/argos'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                ARGOS 爱格视™全功能3D近视训练仪
              </Link>
              <Link to='/eyepal'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                EYEPAL 眼派™可视温润舒眼仪
              </Link>
              {/* <Link to='/glaucoma'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                创新青光眼治疗方案
              </Link>
              <Link to='/strabismus'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                斜视术后康复数字疗法
              </Link> */}
            </div>
            <div className='App_footer-topRightItem'>
              <div className="App_footer-title">公司动态</div>
              <Link to='/companyNews'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                最新资讯
              </Link>
            </div>
            <div className='App_footer-topRightItem'>
              <div className="App_footer-title">FCST研究院</div>
              <Link to='/fcst'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                文献速递
              </Link>
              <Link to='/fcst'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                科普专栏
              </Link>
            </div>
            <div className='App_footer-topRightItem'>
              <div className="App_footer-title">联系我们</div>
              <Link to='/aboutUs'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                公司地址
              </Link>
              <Link to='/aboutUs'
                className="App_footer-subitem"
                onClick={scrollTop}
              >
                联系方式
              </Link>
            </div>
          </div>
          {/* 移动端 */}
          <div className='App_footer-Mobile'>
            <ul>
              {menuItems.map((item) => {
                const menuState = {
                  ABOUT: isAboutOpen,
                  PRODUCTS: isProductsOpen,
                  NEWS: isNewsOpen,
                  FCST: isFcstOpen,
                  CONTACT: isContactOpen,
                };
                const isOpen = menuState[item.type];
                return <li key={item.title}>
                  <div
                    className="flex_row flex_jc-sb flex_ai-c"
                    style={{
                      color: isOpen ? "#2A82E4" : "#23253B",
                    }}
                    onClick={toggleMenu(item.type)}
                  >
                    <div className="fz_12 fw_700 lh_16">{item.title}</div>
                    <img
                      className={`mobile-arrow ${isOpen ? "open" : ""}`}
                      src="/images/nav/expand_icon.svg"
                      alt=""
                    />
                  </div>
                  {isOpen && (
                    <div className="Footer_mobile-sbuNav open">
                      <ul>
                        {item.links.map((link) => (
                          <li key={link.text}>
                            <div
                              className='fz_12 fw_700 c_85899E'
                              onClick={(() => {
                                navigate(link.href)
                              })}>
                              {link.text}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="App_footer-bottom">
        <div className='App_footer-bottomContent pageMargin'>
          <div>Copyright©2022.集视集团 All rights reserved.</div>
          <a
            href="https://beian.miit.gov.cn"
            target='_blank'
            style={{ color: '#ffffff', textDecoration: 'none' }}
          >
            浙ICP备2022037241号-2
          </a>
        </div>
      </div>
    </div >
  );
}
